import { Component, OnInit, ViewChild } from '@angular/core';
import { AppInformationService, ArkUnitOfWork, AuthService } from 'app/core/core.module';
import { CommitteeAttachment, CommitteeAttachmentEmail } from 'app/core/model/entity-model';
import { DxDataGridComponent, DxHtmlEditorComponent } from 'devextreme-angular';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-email-history',
    templateUrl: './email-history.component.html',
    styleUrls: ['./email-history.component.scss'],
    standalone: false,
})
export class EmailHistoryComponent implements OnInit {
    emails: CommitteeAttachmentEmail[] = [];
    isAdmin: boolean = false;
    committees: any;
    committeeId: number;
    executiveMembers: any;
    processing = false;
    serviceName = environment.serviceName;
    uploadHeaders: any;
    mode: string;
    valueContent: any;
    agenda: any;
    selectedAgenda: CommitteeAttachment;
    items: any[] = [];
    disableSelection: boolean = false;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    @ViewChild('editor') editor: DxHtmlEditorComponent;

    constructor(
        private uow: ArkUnitOfWork,
        private auth: AuthService,
        public appInfo: AppInformationService,
    ) {}

    async ngOnInit() {
        this.committees = this.uow.lookups.committees;
        this.isAdmin = this.auth.hasRole('Executive:Admin');
        await this.getData();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        const emails = (await this.uow.getCommitteeAttachmentEmails(this.isAdmin ? null : this.auth.currentUser.userName, 'attachmentLinks.attachment')) as any[];
        emails.forEach((email) => {
            const attachmentList = [];
            if (email.sentTo) email.sentToHtml = email.sentTo.split(';').join('<br>');
            email.attachmentLinks.forEach((link) => {
                attachmentList.push(link.attachment.name);
            });
            email.attachmentList = attachmentList.join('<br/>');
        });
        this.emails = emails;
        this.appInfo.pleaseWaitHide();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            template: 'toolbarText',
            location: 'before',
        });
    }
}
